import React from 'react';
import { motion } from 'framer-motion';
import type { Content } from '../content/types';
type Props = {
  content: Content['problem'];
};
export function Problem({
  content
}: Props) {
  return <section className="bg-brand-darker py-16 sm:py-24 lg:py-32 px-5 sm:px-6" data-id="element-81">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8
    }} className="max-w-[680px] mx-auto text-center flex flex-col items-center" data-id="element-82">
        <h2 className="text-[28px] sm:text-[36px] lg:text-[42px] font-bold text-brand-gold mb-8 sm:mb-12 leading-tight" data-id="element-83">
          {content.title}
        </h2>

        <div className="space-y-5 sm:space-y-6 text-[16px] sm:text-[18px] text-brand-cream leading-[1.75] sm:leading-[1.8]" data-id="element-84">
          {content.paragraphs.map((p, i) => <p key={i} data-id="element-85">{p}</p>)}
        </div>
      </motion.div>
    </section>;
}